/**
 * Seitenleisten-Panel „Ähnliche Tickets" (Spec 9.5: „So wurde es gelöst").
 *
 * Die Liste kommt fertig gefiltert vom Server — eigener Mandant, eigene
 * Scopes, gelöste Tickets zuerst. Hier wird sie nur angezeigt.
 */
import type { SimilarTicket } from '@tickethub/shared';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Badge } from '@/components/ui/badge';

type SimilarTicketsProps = {
  items: SimilarTicket[];
  loading: boolean;
};

export function SimilarTickets({ items, loading }: SimilarTicketsProps) {
  const { t } = useTranslation();

  return (
    <section className="space-y-2 rounded-lg border p-4" aria-label={t('ai.similar_title')}>
      <h2 className="text-sm font-medium">{t('ai.similar_title')}</h2>

      {loading ? (
        <p className="text-sm text-muted-foreground">{t('common.loading')}</p>
      ) : items.length === 0 ? (
        <p className="text-sm text-muted-foreground">{t('ai.similar_empty')}</p>
      ) : (
        <ul className="space-y-2">
          {items.map((item) => (
            <li key={item.ticket_id} className="text-sm">
              <Link className="hover:underline" to={`/tickets/${item.ticket_id}`}>
                <span className="font-mono text-xs text-muted-foreground">{item.number}</span>{' '}
                {item.subject}
              </Link>
              <div className="mt-1 flex items-center gap-2">
                <Badge variant="outline">{t(`ticket.status_${item.status}`)}</Badge>
                <span className="text-xs text-muted-foreground">
                  {t('ai.similar_score', { score: item.score.toFixed(2) })}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
